module.exports = __webpack_public_path__ + "static/img/geometry5.58ebf0c9.png";